import { IEntitlement } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

function useEntitlementsNew(
  companyId: number,
  filters?: { corporationId?: number }
) {
  const query = new URLSearchParams();
  if (companyId) query.set('companyId', companyId.toString());

  if (filters?.corporationId)
    query.set('corporationId', filters.corporationId.toString());

  const URL = query?.toString()
    ? `entitlements-new/list?${query.toString()}`
    : null;

  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data?: { entitlements: IEntitlement[]; count: number };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
    isLoading: boolean;
  } = useSWR(
    URL,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading,
  };
}

export { useEntitlementsNew };
